import { PortalPartnerStatusEnum } from '@routellers/types/dist/partners-portal/enum/portal-partner-status.enum';
import type { TFunction } from 'i18next';

import { enumLabel, enumOptions } from '../i18n/enum-options';

export const portalPartnerStatusColors: Record<PortalPartnerStatusEnum, string> = {
    [PortalPartnerStatusEnum.NEW]: 'gray',
    [PortalPartnerStatusEnum.INVITE_SENT]: 'blue',
    [PortalPartnerStatusEnum.LANDING_OPENED]: 'cyan',
    [PortalPartnerStatusEnum.REGISTERED]: 'green',
    [PortalPartnerStatusEnum.HAS_ORDERS]: 'teal',
    [PortalPartnerStatusEnum.CLOSED]: 'dark',
    [PortalPartnerStatusEnum.BLOCKED]: 'red',
    [PortalPartnerStatusEnum.REJECTED]: 'orange',
};

export const portalPartnerStatusLabel = (t: TFunction, value: PortalPartnerStatusEnum) =>
    enumLabel(t, 'enums.portalPartnerStatus', value);

export const portalPartnerStatusOptions = (t: TFunction) =>
    enumOptions(Object.values(PortalPartnerStatusEnum), t, 'enums.portalPartnerStatus');
